export default {
    "시작하기": "시작하기",
    "다운로드": "다운로드"
}